<script setup lang="ts">
import { computed, ref } from 'vue';

import useField from '@/composables/useField';

export type FieldSize = 'xs' | 'sm' | 'md';

export interface Props {
  modelValue?: boolean;
  size?: FieldSize;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  size: 'md',
});
const emit = defineEmits<{
  'update:modelValue': [value: (typeof props)['modelValue']];
}>();

const fieldValue = ref(props.modelValue);

useField(props, fieldValue, (newFieldValue) => {
  emit('update:modelValue', newFieldValue as (typeof props)['modelValue']);
});

const sizeClass = computed(() => 'size-' + props.size);
</script>

<template>
  <v-checkbox
    v-model="fieldValue"
    :class="[$style.kCheckboxField, $style[sizeClass]]"
    data-testid="kCheckboxField"
    density="compact"
  >
  </v-checkbox>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.kCheckboxField {
  :global {
    .v-selection-control {
    }
      .v-selection-control__wrapper {
      }
        .v-selection-control__input > .v-icon {
          opacity: 1;
          color: colors.$color-brand-800;
        }
      .v-label {
        opacity: 1;
        color: inherit;
      }
  }
}

.size-xs {
  --v-input-control-height: #{variables.$btn-xs-height};

  :global {
    .v-selection-control {
      --v-selection-control-size: #{variables.$btn-xs-height - 12};
    }
      .v-selection-control__wrapper {
        margin-left: -4px;
      }
        .v-selection-control__input > .v-icon {
          font-size: 17px;
        }
      .v-label {
        font-size: 14px;
        margin-left: 1px;
      }
  }
}

.size-sm {
  --v-input-control-height: #{variables.$btn-sm-height};

  :global {
    .v-selection-control {
      --v-selection-control-size: #{variables.$btn-sm-height - 12};
    }
      .v-selection-control__wrapper {
        margin-left: -4px;
      }
        .v-selection-control__input > .v-icon {
          font-size: 20px;
        }
      .v-label {
        font-size: 14px;
        margin-left: 1px;
      }
  }
}

.size-md {
  --v-input-control-height: #{variables.$btn-md-height};

  :global {
    .v-selection-control {
      --v-selection-control-size: #{variables.$btn-md-height - 12};
    }
      .v-selection-control__wrapper {
        margin-left: -5px;
      }
        .v-selection-control__input > .v-icon {
          font-size: 24px;
        }
      .v-label {
        font-size: 16px;
        margin-left: 1px;
      }
  }
}
</style>
